import React from 'react';
import { ErgoTask } from '../types';

export default React.createContext<{ tasks: ErgoTask[], setTasks: (tasks: ErgoTask[]) => void }>({ tasks: [], setTasks: (tasks) => { } });

